var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(" Hier kannst du den aktuellen Spielstand vom Spiel sehen. Bei einer aktiven Internetverbindung aktualisiert sich diese Seite automatisch. ")]),_c('LiveRankComponent',{attrs:{"gameId":_vm.gameId}}),_c('br')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }